import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { Grid } from "semantic-ui-react";
import PrimaryButton from "../../../components/Button/PrimaryButton";
import styles from "./OrderCard.module.scss";
import {
  Body2,
  Heading3,
} from "../../../components/value-cssmodules/TextComponent";
import { cartTotalPriceSelector } from "../../../utils/selectors";

const OrderCard = ({
  cartLength,
  order,
}: {
  cartLength: number;
  order?: () => void;
}) => {
  const totalPrice = useSelector((state) => cartTotalPriceSelector(state));
  // const {totalPrice} = useSelector((state: any) => state?.orderDetails?.order)
  console.log(totalPrice)
  const { total } = useSelector((state: any) => state.promo)

  return (
    <Grid className={styles.self}>
      <Grid.Row centered>
        <Grid.Column>
          <Heading3 className={styles.items} centered>
            <FormattedMessage id={"order.card.title"} />
          </Heading3>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Body2>
            <FormattedMessage
              id="order.card.items"
              defaultMessage="Total items: {count}"
              values={{ count: cartLength }}
            />
          </Body2>
          <Body2>
            <FormattedMessage
              id="order.card.totalPriceLabel"
              defaultMessage="Total price: {price}"
              values={{ price: total || totalPrice }}
            />
          </Body2>
          {order && (
            <PrimaryButton
              onClick={order}
              disabled={cartLength === 0}
              text={<FormattedMessage id={"order.card.finalize"} />}
            />
          )}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default OrderCard;
